import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import NavBlock from '../components/NavBlock'
import HomeSecureTopThreats from '../components/HomeSecureTopThreats'
import HomeSecureCategoriesBlocked from '../components/HomeSecureCategoriesBlocked'
import HomeSecureThreatClock from '../components/HomeSecureThreatClock'
import AjaxLoader from '../components/AjaxLoader'

const NAV_CLOCK = 'clock'
const NAV_THREATS = 'threats'
const NAV_CATEGORIES = 'categories'

const DURATIONS = [
    { title: '24 hrs', value: 'last24h' },
    { title: '7 days', value: 'last7d' },
    { title: '30 days', value: 'last30d' }
]

const ThreatsBlocked = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [data, setData] = useState({
        virusesBlocked: {},
        malwareBlocked: {},
        phishingBlocked: {},
        contentBlocked: {},
        categoriesBlocked: {}
    })
    const [activeNavItem, setActiveNavItem] = useState(NAV_CLOCK)
    const [isLoadingTab, setIsLoadingTab] = useState(false)
    const [activeDuration, setActiveDuration] = useState(DURATIONS[1])
    const [isLoadingDuration, setIsLoadingDuration] = useState(false)

    useEffect(() => {
        DataSource.getData(`/api/getThreatsBlocked/${props.serviceId}`, response => {
            setIsLoaded(true)
            setData(response)
        }, () => {
            setHasError(true)
            setIsLoaded(true)
        })
    }, [])

    const getBlockedCount = type => {
        const result = data[type] && data[type][activeDuration.value] ? parseInt(data[type][activeDuration.value]) : 0

        return nFormatter(result, 1)
    }

    const nFormatter = (num, digits = 0) => {
        const si = [
            { value: 1, symbol: '' },
            { value: 1E3, symbol: 'K' },
            { value: 1E6, symbol: 'M' },
            { value: 1E9, symbol: 'G' },
            { value: 1E12, symbol: 'T' },
            { value: 1E15, symbol: 'P' },
            { value: 1E18, symbol: 'E' }
        ]
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
        let i

        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break
            }
        }

        return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
    }

    const handleChangeTab = value => {
        setIsLoadingTab(true)
        setActiveNavItem(value)
        setTimeout(() => {
            setIsLoadingTab(false)
        }, 250)
    }

    const handleChangeDuration = (event, item) => {
        event.preventDefault()
        setIsLoadingDuration(true)
        setActiveDuration(item)
        setTimeout(() => {
            setIsLoadingDuration(false)
        }, 250)
    }

    const Header = title => {
        return (
            <React.Fragment>
                <p className='m-0 mb-4 mt-3 bold font-larger color-indigo'>{title}</p>
                <div className='d-flex justify-content-center align-items-center'>
                    {DURATIONS.map((item, key) => {
                        return (
                            <a
                                key={key}
                                href='#'
                                className={`
                                ${item.value === activeDuration.value ? 'bold underline' : 'sub-bold color-indigo'}
                                ${key === 2 ? '' : 'mr-5'}
                                gtm-change-threats-blocked-duration
                            `}
                                onClick={event => handleChangeDuration(event, item)}
                            >{item.title}
                            </a>
                        )
                    })}
                </div>
            </React.Fragment>
        )
    }

    const Content = () => {
        if (isLoadingTab) {
            return (
                <div className='col-12 d-flex justify-content-center align-items-center'>
                    <AjaxLoader />
                </div>
            )
        } else if (activeNavItem === NAV_THREATS) {
            return (
                <HomeSecureTopThreats
                    virusCount={getBlockedCount('virusesBlocked')}
                    malwareCount={getBlockedCount('malwareBlocked')}
                    phishingCount={getBlockedCount('phishingBlocked')}
                    contentCount={getBlockedCount('contentBlocked')}
                    isLoadingDuration={isLoadingDuration || !isLoaded}
                    duration={activeDuration.value}
                >
                    {Header(`Threats blocked in the past ${activeDuration.title}`)}
                </HomeSecureTopThreats>
            )
        } else if (activeNavItem === NAV_CLOCK) {
            return <HomeSecureThreatClock total={props.totalThreatCount} />
        } else if (activeNavItem === NAV_CATEGORIES) {
            return (
                <HomeSecureCategoriesBlocked
                    categories={data.categoriesBlocked[activeDuration.value] ? data.categoriesBlocked[activeDuration.value] : {}}
                    isLoadingDuration={isLoadingDuration || !isLoaded}
                    duration={activeDuration.value}
                >
                    {Header(`Top 5 content categories blocked in the past ${activeDuration.title}`)}
                </HomeSecureCategoriesBlocked>
            )
        }
    }

    return (
        <div className='module'>
            <Heading title='Threats blocked' />
            <ModuleWithLoader isLoaded hasError={hasError} className='p-4'>
                <div className='row'>
                    <div className='col-12 col-md-10 offset-md-1 text-center mb-4'>
                        <NavBlock
                            items={[
                                { title: 'Your cyberthreat clock', value: NAV_CLOCK },
                                { title: 'Top threats', value: NAV_THREATS },
                                { title: 'Top categories blocked', value: NAV_CATEGORIES }
                            ]}
                            handleClick={handleChangeTab}
                            activeItem={activeNavItem}
                            className='gtm-hs-change-threats-blocked-tab'
                        />
                    </div>
                </div>
                {Content()}
            </ModuleWithLoader>
        </div>
    )
}

ThreatsBlocked.propTypes = {
    serviceId: PropTypes.number.isRequired,
    totalThreatCount: PropTypes.number.isRequired
}

ThreatsBlocked.defaultProps = {
    totalThreatCount: 0
}

export default ThreatsBlocked



// WEBPACK FOOTER //
// ./resources/js/modules/ThreatsBlocked.js